module.exports = __webpack_public_path__ + "img/prj031.14a67c61.png";